import Vue from 'vue';
import { IJSONSchema } from '../../../plugins/validation/IJSONSchema';
import queryBuilder from '../../../plugins/validation/queryBuilder';
import TokenRequestModel from '../../generated/types/model/resource/TokenRequestModel';

export default class TokenRequestViewModel extends TokenRequestModel {
  schema = {
    ...queryBuilder.properties({
      userName: { required: true },
      password: { required: true, minLength: Vue.$config.values['auth-min-password-length'] ?? 0 },
    }),
  } as IJSONSchema;
}
